<div
  class="redes-sociales"
  [ngClass]="{
    home: currentRoute === '/inicio' && !isSmallScreen
  }"
>
  <a href="https://www.facebook.com/Colegiodearquitectostabasquenos">
    <img
      src="assets/img/redes-sociales-01.svg"
      width="50"
      alt="Icono Facebook"
    />
  </a>
  <a href="https://twitter.com/arquitectostab">
    <img
      src="assets/img/redes-sociales-02.svg"
      width="50"
      alt="Icono Twitter"
    />
  </a>
  <a href="mailto:cat@arquitab.org.mx">
    <img src="assets/img/correo-circulo.svg" width="43" alt="Icono Correo" />
  </a>
</div>
